import { getArticleBySlug } from 'helpers/strapi'
import { ArticleMinimalDataType, ArticleType } from 'helpers/strapi/types'
import { ArticlePage } from 'routes/Articles/Category/Article'
import {
  fetchArticles,
  getRecentPostsExcept,
} from 'helpers/strapi/fetch-strapi'
import { ARTICLE_REVALIDATE_TIME, HIDDEN_CATEGORIES } from 'routes/constants'

export default function Article({
  article,
  recentPosts,
}: {
  article: ArticleType
  recentPosts: ArticleMinimalDataType[]
}) {
  return <ArticlePage article={article} recentPosts={recentPosts} />
}

export async function getStaticPaths() {
  const articles = await fetchArticles({})

  const articlesToRender = articles.data
    .map((article) => ({
      slug: article?.attributes?.slug,
      category: article?.attributes?.category?.data?.attributes?.slug,
    }))
    .filter(
      ({ slug, category }) =>
        slug && category && !HIDDEN_CATEGORIES.includes(category),
    )

  return {
    paths: articlesToRender.map(({ slug, category }) => ({
      params: { slug, category },
    })),
    fallback: true, // false or "blocking"
  }
}

export async function getStaticProps({ params }: { params: { slug: string } }) {
  const article = await getArticleBySlug(params.slug)
  const recentPosts = await getRecentPostsExcept([params.slug])

  if (!article) {
    return {
      redirect: {
        permanent: false,
        destination: './../', // Redirect to Articles page
      },
      revalidate: 1, // Do not save not-found article in cache and revalidate it every second
    }
  }

  return {
    props: {
      article,
      recentPosts: recentPosts ?? [],
    },
    revalidate: ARTICLE_REVALIDATE_TIME, // In seconds
  }
}
